import styled, { css } from 'styled-components';
import {
    flexbox,
    justifyContent,
    alignItems,
    flex,
    flexDirection,
    flexShrink,
    inlineFlexbox
} from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';
import Container from '../container';

const headerColumn = (() => css`
    height: 100%;
    padding-left: 10px;
    text-align: left;
    word-wrap: break-word;
    line-height: 52px;
`);

const SpinnerWrapper = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const CourseCreatorWrapper = styled.div((props) => {
    const { colours, palette, typography } = ThemeHelper.getTheme(props);

    return `
        font-family: ${typography.family};

        .header {
            ${flexbox()}
            ${alignItems('center')}
            background-color: ${colours.iron};
        }

        .mainHeading {
            ${flexbox()}

            font-family: ${typography.family};
            padding: 0 25px;
            font-size: 30px;
            font-weight: 500;

            ${flexbox('center')}
            ${justifyContent('space-between')}

            height: 80px;
        }

        .title {
            color: ${colours.nevada};
            margin: auto;
            font-size: 30px;
            font-weight: 500;
            ${flex(1)}
        }

        & > ${Container} {
            margin-bottom: 80px;
        }

        .footer {
            ${flexbox()}
            ${alignItems('center')}
            ${justifyContent('flex-end')}

            position: fixed;
            height: 50px;
            bottom: 0.1px;
            left: 0.1px;
            width: 100%;
            padding-right: 10px;
            padding-left: 10px;
            background-color: ${palette.tertiary.main};
        }

        .save {
            width: 130px;
        }

        .publish {
            width: 95px;
        }

        .back {
             width: 95px;
        }

        .savePanel {
            ${flexbox()}
            ${justifyContent('flex-end')}
            width: 90%;

            & > div {
                margin-left: 10px;
            }
        }

        .backPanel {
             width: 10%;
        }

        .content {
            ${flexbox()}
            ${flexDirection('column')}
            width: calc(100% - 16px);
            height: calc(100vh - 167px);
            margin: 8px 7px;
            background-color: ${palette.primary.text};
            box-shadow: 5px 5px 1px lighten(${colours.lightGreyShadow}, 70%);
            border-radius: 6px;
        }

        .courseName {
            color: ${palette.primary.main};
            font-family: ${typography.family};
            font-size: 19px;
            font-weight: 500;
            line-height: 27px;
            padding: 0px;

            input, .icon {
                min-height: 40px;
            }

            .icon {
                margin-top: 10px;
            }
        }

        .course {
            ${flexbox()}
            padding : 10px;
        }

        .courseInfoContainer {
            padding-right:10px;
        }

        .courseHeading {
            height: 18px;
            color: ${palette.primary.dark};
            font-family: ${typography.family};
            font-size: 16px;
            font-weight: 400;
        }

        .courseInfo {
            height: 18px;
            color: ${palette.primary.dark};
            font-family: ${typography.family};
            font-size: 13px;
        }

        .coursePanel {
            ${flexbox()}
            ${flexDirection('column')}
        }

        .header {
            ${flexbox()}
            ${flexShrink(0)}
            height: 50px;
            color: ${palette.primary.main};
            font-family: ${typography.family};
            font-size: 13px;
            font-weight: 600;
            line-height: 27px;
        }

        .treeColumn {
            ${headerColumn()}
            background-color: ${palette.primary.text};
            border-top: 1px solid ${palette.tertiary.main}
            border-bottom: 1px solid ${palette.tertiary.main}
            width: calc(100%/3);
        }

        .searchColumn {
            ${headerColumn()}
            background-color: ${palette.primary.text};
            border: 1px solid ${palette.tertiary.main};
            border-right: none;
            width: calc(100%/3);
        }

        .topicColumn {
            ${headerColumn()}
            ${flexbox()}
            background-color: ${palette.primary.text};
            border-left: 1px solid ${palette.tertiary.main}
            border-top: 1px solid ${palette.tertiary.main}
            border-bottom: 1px solid ${palette.tertiary.main}
            width: calc(100%/3);
        }

        .panelRow {
            ${flexbox()}
            height: 100vh;
        }

        .treeRows {
             width: calc(100%/3);
             transition: width 0.2s;
        }

        .fullWidth {
            width: 100%;
            transition: width 0.2s;
        }

        .spineRows {
             border-left: 1px solid ${palette.tertiary.main}
             width: calc(100%/3);
        }

        .topics {
             border-left: 1px solid ${palette.tertiary.main}
             width: calc(100%/3);
             padding: 10px;
             overflow: auto;
        }

        .curriculumHeaderName {
            float: left;
            padding-left: 10px;
        }

        .topicHeader {
            ${flexbox()}
            ${alignItems('center')}

            &Icons {
              ${flexbox()}
              padding-left: 10px;
              margin-top: -15px;
            }

            &Name {
                text-align: left;
            }

            &Add {
                ${flexbox()}
                ${flex(1)}
                ${justifyContent('center')}
                ${alignItems('center')}
                padding-right: 10px;
                >div {
                    padding: 10px;
                }
            }

            &NewTopic {
                ${flexbox()}
                ${flex(1)}
                ${justifyContent('flex-end')}
                padding-right: 10px;
                >div {
                    padding: 10px;
                }
            }
        }

        .iconStyle {
            width: 18px;
            height: 25px;
            margin-right:4px;
            outline: none;
            cursor: pointer;
        }

        .newTopicButton {
            height: 36px;
        }

        .topicList {
            padding: 6px;
        }

        .topicPanel {
            height: 100%;
            overflow: auto;
        }

        .hide {
            display: none;
        }

        .dropZone {
            height: 50px;

            &:hover {
                border: 2px solid ${palette.primary.light};
                border-style: dashed;
            }
        }

        .hideRow {
            width: 0%;
            display: none;
        }

        .icon {
            width: 20px;
            height: 21px;
            margin-top: 5px;
            margin-right: 10px;
            margin-left: 10px;
            float: right;
            cursor: pointer;
            outline: none;
        }

        .expand {
            width: 20px;
            height: 21px;
            margin-top: 5px;
            margin-right: 10px;
            margin-left: 10px;
            float: left;
            cursor: pointer;
            outline: none;
        }

        .checkbox {
            ${inlineFlexbox()};

            margin: -5px;

            .chklabel {
                width: 20px;
                height: 20px;
                border: 1px solid ${colours.silverDark};
                border-radius: 3px;
                margin-top: 4px;
            }

            .name {
                display: none;

                &:checked + label::after{
                    background-color: white !important;
                    content: "\f00c";
                    color: black;
                    font-family: "FontAwesome";
                    font-size: 16px;
                    top: 0px;
                    left: 12px;
                    position: absolute;
                    height: 0px;
                }
            }
        }

        .spineNode {
            width: 100px;
            padding: 5px !important;
        }
    `;
});

const ModalButtons = styled.div`
    ${flexbox()}
    & > div {
        margin: 5px;
    }

    .publish {
        width: 220px;
        height: 50px;
    }
`;

const CourseInfoWrapper = styled.div`
    display: inline-block;
    margin: 0 15px;
    max-height: 20px;
`;

export { CourseCreatorWrapper, ModalButtons, CourseInfoWrapper, SpinnerWrapper };



// WEBPACK FOOTER //
// ./app/components/course-creator/styled.js